<div class="premier-dialog-container">
  <button class="close-btn" mat-icon-button (click)="close()" aria-label="Close Amazon Nova Premier Info">
    <span aria-hidden="true"><i class="fas fa-bars"></i></span>
  </button>
  <div class="icon-title-row">
     <img src="assets/logos/amazon.svg" alt="Amazon Nova Premier Logo" class="model-icon" />
    <h2>Amazon Nova Pro</h2>
  </div>
  <p class="subtitle">**Power, Precision, &amp; Enterprise-Ready AI**</p>

  <section>
    <h3>Why Choose Amazon Nova Pro?</h3>
    <ul>
      <li>
        <b>High-Throughput Performance:</b> Nova Pro is optimized for enterprise-scale workloads, offering lightning-fast generation for chat, summarization, and content creation.
      </li>
      <li>
        <b>Deep Context Retention:</b> Handles long-form conversations and documents without losing track of context.
      </li>
      <li>
        <b>Data Security &amp; Compliance:</b> Built to meet AWS’s highest compliance standards. Trusted for sensitive enterprise, medical, and financial data.
      </li>
      <li>
        <b>Multimodal Ready:</b> Supports text, code, and soon—images and video!
      </li>
      <li>
        <b>Reliable Uptime:</b> Backed by Amazon’s robust cloud infrastructure for always-on access.
      </li>
    </ul>
  </section>

  <section>
    <h3>When to Use Nova Pro</h3>
    <ul>
      <li>
        <span class="badge use-case">Enterprise Chatbots</span>  
        When you need large, reliable conversational flows.
      </li>
      <li>
        <span class="badge use-case">Data Analysis</span>
        For extracting and summarizing insights from huge volumes of text.
      </li>
      <li>
        <span class="badge use-case">Secure Apps</span>
        Handling medical, financial, or regulated conversations.
      </li>
      <li>
        <span class="badge use-case">Long Context</span>
        Keeping multi-turn dialog or documents on-topic.
      </li>
      <li>
        <span class="badge use-case">Fast, Consistent Results</span>
        For production apps and 24/7 critical workflows.
      </li>
    </ul>
  </section>

  <section class="pro-tip">
    <strong>Pro Tip:</strong> Nova Pro excels when speed, context, and security matter. It's a top choice for scaling AI in the enterprise!
  </section>
</div>
